export default __webpack_public_path__ + "static/media/0463_IMG5546.cbb5f9a5.jpg";